import { module } from 'modujs';
import { lazyLoadImage } from '../utils/image';
import LocomotiveScroll from 'locomotive-scroll';
import { html } from '../utils/environment';
import IS_TOUCH_DEVICE from '../app';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);
    }

    init() {
        this.bindEvents();

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    bindEvents() {
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind);
        this.resizeObserver = new ResizeObserver(() => {
            this.update();
        });
        this.resizeObserver.observe(this.el);
    }

    unbindEvents() {
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind);
        this.resizeObserver.disconnect();
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        lazyLoadImage(args.obj.el, null, () => {
            //callback
        })
    }

    update() {
        this.scroll?.update();
    }

    scrollTo(param) {
        this.scroll?.scrollTo(param.target, param.options)
    }

    onFontsLoaded() {
        // setTimeout(() => {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: true
        });

        this.scroll.on('call', (func, way, obj, id) => {
            // Using modularJS
            this.call(func[0], { way, obj }, func[1], func[2]);
        });

        this.scroll.on('scroll', (args) => {
            if (typeof args.currentElements['timelineBw'] === 'object') {
                let currentElement = args.currentElements['timelineBw'];
                this.call('onScroll', { currentElement, args }, 'TimelineBw');
            }

            if(typeof args.currentElements['footer'] === 'object') {
                html.classList.add('is-footer-visible');
                
            } else {
                html.classList.remove('is-footer-visible');
            }

            if (!IS_TOUCH_DEVICE) {
                if (args.scroll.y >= args.limit.y - 60) {
                    html.classList.add('is-bottom');
                } else {
                    html.classList.remove('is-bottom');
                }
                if (args.scroll.y <= 60) {
                    html.classList.add('is-top');
                } else {
                    html.classList.remove('is-top');
                }
                // if footer is visible add class is-footer-visible on html
            }
        });
        // }, 10);
        setTimeout(() => {
            this.update();
        }, 20);
    }

    destroy() {
        this.scroll.destroy();
        this.unbindEvents();
    }
}
